// Columns of the schedule grid (R-S6): the rooms or tracks of the event, and one more column for the slots that stand in none of
// them — no room, or a room removed from the taxonomy. Such a slot still takes time in the program, so it stays visible (audit 31.10, P2-10).

export interface GridColumn { id: string; name: string; orphan?: boolean }
/** The id of the extra column: not a term, so nothing can be dropped into it. */
export const ORPHAN = '';

export function gridColumns(columns: { id: string; name: string }[], values: unknown[], axis: 'room' | 'track'): GridColumn[] {
  const known = new Set(columns.map((c) => c.id));
  const stray = values.some((v) => typeof v !== 'string' || !known.has(v));
  return stray ? [...columns, { id: ORPHAN, name: axis === 'room' ? 'Без зала' : 'Без трека', orphan: true }] : columns;
}

/** The column a slot stands in: its room or track, or the extra one. */
export function columnOf(columns: GridColumn[], value: unknown): number {
  const i = typeof value === 'string' && value ? columns.findIndex((c) => !c.orphan && c.id === value) : -1;
  return i >= 0 ? i : columns.findIndex((c) => c.orphan);
}
